// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { DetectionZoneCardinalDirection } from "./Shared.DetectionZoneCardinalDirection.gen";

export interface IDirectionNameJson {
	direction: DetectionZoneCardinalDirection;

	name: string | undefined;

	$type?: string | undefined;
}
export class DirectionNameJson {
	constructor(data?: IDirectionNameJson) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	direction: DetectionZoneCardinalDirection = 0;

	name: string | undefined;

	static $type: string = "CoreApi.Models.Reports.DirectionNameJson, ";
	$type?: string | undefined = DirectionNameJson.$type;
}

